module.exports = __webpack_public_path__ + "static/media/11880222_989166291104793_187740422_n.ca24d172.jpg";